import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "hoverContent"];
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { POPOVER_ANIMATION_DURATION } from 'foundations-components/constants';
import { Box } from 'foundations-components/transitional/components/Box';
import PropTypes from 'prop-types';
import { Component } from 'react';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const POPOVER_TRANSITION_DELAY = parseInt(POPOVER_ANIMATION_DURATION, 10);
// Modified from UIComponents/table/UITableHoverCell to use <div> instead of <td>
export default class HoverComponent extends Component {
  constructor(props) {
    super(props);
    this.handleHoverContentOpenChange = evt => {
      const rowIsHovered = evt.target.value;
      if (!rowIsHovered !== this.state.hoverContentIsClosing) {
        // Remove hover content's left margin while closing (#2412)
        this.setState({
          hoverContentIsClosing: !rowIsHovered
        });
      }
      this.setState({
        rowIsHovered
      });
      if (rowIsHovered) {
        clearTimeout(this._hideTimeout);
        this.setState({
          hoverContentIsClosed: false
        });
      } else {
        this._hideTimeout = setTimeout(() => {
          this.setState({
            hoverContentIsClosed: true
          });
        }, POPOVER_TRANSITION_DELAY);
      }
    };
    const _rowIsHovered = false;
    this.state = {
      rowIsHovered: _rowIsHovered,
      hoverContentIsClosed: !_rowIsHovered,
      hoverContentIsClosing: false
    };
  }
  componentWillUnmount() {
    clearTimeout(this._hideTimeout);
  }
  render() {
    const _this = this,
      {
        props: {
          children,
          hoverContent
        },
        state: {
          hoverContentIsClosed,
          hoverContentIsClosing,
          rowIsHovered
        }
      } = _this,
      rest = _objectWithoutPropertiesLoose(_this.props, _excluded);
    const isScreenReaderOnly = hoverContentIsClosed && !rowIsHovered;
    return /*#__PURE__*/_jsx(View, Object.assign({
      padding: "0",
      borderWidth: "0",
      inlineSize: "100%"
    }, rest, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        inlineSize: "100%",
        blockSize: "100%",
        children: [children, /*#__PURE__*/_jsx(Box, {
          grow: 1
        }), /*#__PURE__*/_jsx("div", {
          className: isScreenReaderOnly ? 'sr-only' : undefined,
          children: /*#__PURE__*/_jsx(Box, {
            marginInlineStart: hoverContentIsClosing && !rowIsHovered ? '0' : undefined,
            children: /*#__PURE__*/_jsx(UITableHoverContent, {
              className: "display-flex",
              open: rowIsHovered,
              onOpenChange: this.handleHoverContentOpenChange,
              shrinkOnHide: true,
              children: hoverContent
            })
          })
        })]
      })
    }));
  }
}
HoverComponent.propTypes = {
  children: PropTypes.node.isRequired,
  hoverContent: PropTypes.node
};